import React from "react";
import { motion } from "framer-motion";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";
import TID from "@/lib/testIds";

const faqs = [
  {
    q: "What is penetration testing and do I really need it?",
    a: "Penetration testing is a controlled, ethical attack on your systems to surface real-world vulnerabilities before bad actors find them. If you handle customer data, run payments, or expose APIs, periodic pentests are essential and often required by frameworks like SOC 2, ISO 27001 and PCI-DSS.",
  },
  {
    q: "Which marketing channels do you specialise in?",
    a: "We run high-performance campaigns across Meta (Facebook & Instagram), Google Ads, YouTube and LinkedIn, paired with SEO, content and conversion-rate optimization. We optimize for measurable outcomes — leads, sales, and ROAS.",
  },
  {
    q: "How is pricing structured?",
    a: "We offer transparent, fixed-scope packages for security engagements and flexible monthly retainers for marketing. After a free consultation, you receive a clear proposal with deliverables, timelines and pricing — no surprises.",
  },
  {
    q: "What is the typical project timeline?",
    a: "Most pentests complete within 1–3 weeks depending on scope. Marketing setup goes live in 7–10 days, with iterative optimization thereafter. Websites typically launch in 3–6 weeks.",
  },
  {
    q: "Do you offer post-delivery support?",
    a: "Yes. Every engagement includes free post-delivery support and the option of monthly maintenance, retesting, or growth retainers.",
  },
  {
    q: "How do you handle confidentiality?",
    a: "All engagements are covered by an NDA. We follow strict data-handling protocols, and security findings are shared only with authorized stakeholders via encrypted channels.",
  },
];

export const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid={TID.faqSection}
      className="relative py-24 md:py-32"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        <div className="text-center">
          <p className="text-sm font-semibold text-brand-blue uppercase tracking-[0.18em]">FAQ</p>
          <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900 dark:text-white">
            Frequently asked questions
          </h2>
          <p className="mt-4 text-slate-600 dark:text-slate-300">
            Can&apos;t find what you need? <a href="#contact" className="text-brand-blue font-semibold hover:underline">Ask us directly.</a>
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-12 rounded-3xl border border-slate-200 dark:border-white/10 bg-white dark:bg-[#0F172A]/70 shadow-elevated p-2 md:p-4"
        >
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={TID.faqItem(i + 1)}
                className="px-4 md:px-5 border-b border-slate-200/70 dark:border-white/10 last:border-0"
              >
                <AccordionTrigger className="text-left font-display text-base md:text-lg font-semibold text-slate-900 dark:text-white hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 dark:text-slate-300 leading-relaxed text-[15px]">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQ;
